module.exports = __webpack_public_path__ + "static/media/miami_beach_Florida.d0b8917f.png";